module.exports = __webpack_public_path__ + "img/kitchen-design-modern-contemporary.1c6610b7.jpg";